<template>
    <div>
        <b-form-group :id="'fieldset-' + id" v-bind="$attrs">
            <b-row>
                <b-col cols="12">
                    <b-input-group class="position-static input-datepicker-range mb-1">
                        <b-input-group-prepend class="position-static w-100">
                            <input
                                type="date"
                                v-model="inputModelFrom"
                                ref="dateInput"
                                :max="inputModelTo"
                                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                placeholder="Select a date"
                                @input="setDateFrom"
                                class="datetext"
                                />
                        </b-input-group-prepend>
                    </b-input-group>
                </b-col>
                <b-col cols="12">
                    <b-input-group class="position-static input-datepicker-range mb-2 width-100">
                        <b-input-group-prepend class="position-static w-100">
                            <input
                                type="date"
                                v-model="inputModelTo"
                                ref="dateInput"
                                :min="inputModelFrom"
                                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                placeholder="Select a date"
                                @input="setDateTo"
                                class="datetext"
                                />
                        </b-input-group-prepend>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-form-invalid-feedback :id="'input-' + id + '-live-feedback'">
                {{ errorMessage }}
            </b-form-invalid-feedback>
        </b-form-group>
    </div>
</template>
<script>
import moment from 'moment';
export default {
    props: ["modelFrom", "modelTo", "errorMessage", "id", "suffix", "prefix", "isEditable", "isUpdatable", "dateToDropupRight"],
    data() {
        return {
            inputModelFrom: this.modelFrom,
            inputModelFromStr: '',
            inputModelTo: this.modelTo,
            inputModelToStr: '',
            prefixExist: (this.prefix ? true : false),
            suffixExist: (this.suffix ? true : false),
            inputDateToDropupRight: (this.dateToDropupRight ? true : false)
        }
    }, 
    methods: {
        setDateFrom() {
            let inputModelDate = '1970-01-01';
            if (this.inputModelFrom != '') {
                inputModelDate = this.inputModelFrom;
            }
            
            let date = new Date(inputModelDate);
            if (date) {
                this.inputModelFromStr = moment(date).format('DD/MM/YYYY');
            }
            this.$emit('update:modelFrom', this.inputModelFrom);
            this.$emit('change')
        },
        setDateTo() {
            let inputModelDate = '1970-01-01';
            if (this.inputModelTo != '') {
                inputModelDate = this.inputModelTo;
            }
            
            let date = new Date(inputModelDate);
            if (date) {
                this.inputModelToStr = moment(date).format('DD/MM/YYYY');
            }
            this.$emit('update:modelTo', this.inputModelTo);
            this.$emit('change')
        },
        clearDateFrom() {
            this.inputModelFromStr = '';
            this.inputModelFrom = '';
            this.$emit('update:modelFrom', this.inputModelFrom);
            this.$emit('change');
        },
        clearDateTo() {
            this.inputModelToStr = '';
            this.inputModelTo = '';
            this.$emit('update:modelTo', this.inputModelTo);
            this.$emit('change');
        }
    },
    mounted() {
        if (this.inputModelFrom != null && this.inputModelFrom != "" && this.inputModelFrom != undefined) {
            let date = new Date(this.inputModelFrom);
            if (date) {
                this.inputModelFromStr = moment(date).format('DD/MM/YYYY');
            }
        }
        if (this.inputModelTo != null && this.inputModelTo != "" && this.inputModelTo != undefined) {
            let date = new Date(this.inputModelTo);
            if (date) {
                this.inputModelToStr = moment(date).format('DD/MM/YYYY');
            }
        }
    },
    computed:{
        formattedDate(value) {
            return value ? format(value, 'yyyy-MM-dd') : '';
        }
    },
    watch: {
        modelFrom(newValue, oldValue) {
            if (newValue == "") {
                this.inputModelFrom = newValue;
            }
        },
        modelTo(newValue, oldValue) {
            if (newValue == "") {
                this.inputModelTo = newValue;
            }
        }
    }
}
</script>
<style scoped lang="scss">
.input-group-text {
    font-size: 0.7rem !important;
}

::v-deep.input-datepicker-range, .input-datepicker-range label {
    line-height: 1.75 !important;
}

::v-deep.btn.btn-secondary, ::v-deep.btn.btn-secondary:active, ::v-deep.btn.btn-secondary:hover {
        background-color: transparent !important;
    }
    ::v-deep.form-control:disabled, .form-control[readonly] {
        background-color: transparent !important;
    }
    ::v-deep::placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }

    ::v-deep:-ms-input-placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }

    ::v-deep::-ms-input-placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }
    .datetext {
        /* Add any custom styling needed to match Bootstrap-Vue's look and feel */
        display: block;
        width: 100%;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    .datetext:focus {
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
</style>